import React from 'react';
import moment from 'moment';
import {baseUrl} from '../url';

class AddAppointment extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            time: '',
            name: '',
            date: '',
            description: '',
            id: this.props.id,
            success: false,
            response: true,
            message: '',
        }
    }
    componentDidMount(){
        const {  type } = this.props;
        
        if(type === 'add'){
            this.setState({
                name: this.props.name,
                id: this.props.id,
            })
        }
        if (type === 'edit'){
            const { details } = this.props;
            const { id, patient, date, time, description } =  details;
            const name = patient.name.first +' '+ patient.name.last;
            this.setState({
                id,
                name,
                date,
                description,
                time,
            });
        }
    }
    handleChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });

        if(e.target.name === 'date'){
            const { time } = this.state;
            let date  = moment(e.target.value).format('YYYY-MM-DD')
            let today = moment().format('YYYY-MM-DD');
            let isAfter = moment(today).isAfter(date);
            let currentTime = moment().format('HH:mm:ss');
            if (isAfter){
                this.setState({
                    dateError: 'Please enter a date from today'
                })
            }
            if(!isAfter){
                this.setState({
                    timeError: '',
                })
            }
            if (time){
                if(today === date){
                    if (time < currentTime){
                        this.setState({
                            timeError: 'Please enter a time from now.'
                        })
                    }
                }
            }
            this.setState({
                date
            })
        }
        if(e.target.name === 'time'){
            let date  = moment(this.state.date).format('YYYY-MM-DD');
            let today = moment().format('YYYY-MM-DD');
            let time = moment(e.target.value, 'HH:mm').format('HH:mm:ss');
            let currentTime = moment().format('HH:mm:ss');
            if(today === date){
                if (time < currentTime){
                    this.setState({
                        timeError: 'Please enter a time from now.'
                    })
                }
            }
            this.setState({
                time
            })
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {date, time, description, dateError, timeError } = this.state;

        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!time){
            this.setState({
                timeError: 'Please enter appointment time'
            })
        }
        if(!description){
            this.setState({
                descriptionError: 'Please write a decription'
            })
        }
        if(date && time && description && !dateError && !timeError){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            // const id = localStorage.getItem('user_id');
            const { id } = this.state;
            let retries = 0;
            let entry = {
                date,
                time,
                description,
            };
            let method = ''
            if(this.props.type === 'add'){
                method = 'POST'
            }
            if(this.props.type === 'edit'){
                method = 'PUT'
            }
            fetch(`${baseUrl}/admin/patients/appointments/${id}`,{
                method,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        const { name, success, time, date, description } = this.state;
        const { handleClose, title } = this.props;
        return(
            <div className="add-appointment">
                <h5>{title}</h5>
                {
                    !success &&
                    <React.Fragment>
                        <form>
                            <label>
                                Appointment for
                                <input type="text" value={name} onChange={this.handleChange}/>
                            </label>
                            <label>
                                Date
                                <input type="date" value={date} onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''} />
                                <span className="error-text">{this.state.dateError}</span>
                            </label>
                            <label>
                                Time
                                <input type="time" value={time} onChange={this.handleChange} name="time" className={this.state.timeError ? 'error-input' : ''} />
                                <span className="error-text">{this.state.timeError}</span>
                            </label>
                            <label>
                                Description
                                <textarea value={description} onChange={this.handleChange} name="description" className={this.state.descriptionError ? 'error-input' : ''}></textarea>
                                <span className="error-text">{this.state.descriptionError}</span>
                            </label>
                            {/* <label>
                                Repeat appointment
                                <div className="radio-buttons">
                                    <input type="radio" name="frequency" id="no-repeat" value="no-repeat" defaultChecked/>
                                    <label htmlFor="no-repeat">No</label>
                                    <input type="radio" name="frequency" id="repeat" value="repeat"/>
                                    <label htmlFor="repeat">Same date &amp; time each month</label>
                                </div>
                            </label> */}
                            <button onClick={this.handleSubmit}>
                                Save
                                {
                                    !this.state.response &&
                                    <i className="fa fa-spinner fa-pulse fa-fw" />
                                }
                            </button>
                        </form>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p>{this.state.message}</p>
                        <button onClick={handleClose}>Okay</button>
                    </div> 
                }
            </div>
        )
    }
}

export default AddAppointment;


// WEBPACK FOOTER //
// ./src/components/patientProfile/AddEditAppointment.js